<div
  class="grid flex-1 grid-cols-1 items-start lg:grid-cols-[minmax(200px,240px)_minmax(360px,1fr)_minmax(300px,420px)]"
>
  <aside
    class="border-r border-solid border-neutral-default surface-neutral-light px-3 pt-6 pb-10 lg:sticky lg:top-16 lg:h-[calc(100vh-4rem)] lg:overflow-y-auto"
  >
    <a
      class="mx-3 mb-5 flex items-center gap-2 rounded-lg border border-solid button-secondary-border-default px-3 py-2 text-[13px] font-medium button-secondary-label hover:button-secondary-bg-hovered"
      [href]="openApiSpecUrl"
    >
      <cca-icon class="text-sm" icon="export" />
      OpenAPI spec
    </a>
    @for (group of navGroups(); track group.name) {
      <div class="mb-4.5">
        <div
          class="px-3 pb-2 text-[11px] font-medium tracking-widest text-neutral-caption uppercase"
        >
          {{ group.name }}
        </div>
        <div class="flex flex-col gap-0.5">
          @for (groupEndpoint of group.endpoints; track groupEndpoint.id) {
            <a
              class="flex items-center gap-2 rounded-md px-3 py-1.5 text-[13px]"
              [class.font-medium]="groupEndpoint.id === endpoint().id"
              [class.sidebar-second-bg-selected]="groupEndpoint.id === endpoint().id"
              [class.sidebar-second-text-selected]="groupEndpoint.id === endpoint().id"
              [class.sidebar-second-text-default]="groupEndpoint.id !== endpoint().id"
              [routerLink]="['/api', groupEndpoint.id]"
            >
              <span
                class="font-code w-9.5 shrink-0 rounded px-1 py-0.5 text-center text-[10px] font-semibold {{
                  methodChipClass(groupEndpoint.method)
                }}"
              >
                {{ groupEndpoint.method }}
              </span>
              <span class="min-w-0 flex-1 truncate">{{ groupEndpoint.title }}</span>
            </a>
          }
        </div>
      </div>
    }
  </aside>

  <article class="px-12 pt-12 pb-24">
    <div class="mb-3.5 flex items-center gap-2.5">
      <span
        class="font-code rounded px-2 py-1 text-[11px] font-semibold {{
          methodChipClass(endpoint().method)
        }}"
      >
        {{ endpoint().method }}
      </span>
      <span
        class="font-code rounded-md border border-solid border-neutral-default surface-neutral-light px-2.5 py-1 text-sm text-neutral-title"
      >
        {{ endpoint().path }}
      </span>
    </div>
    <h1 class="font-display m-0 mb-2.5 text-[26px]! font-bold! text-neutral-title">
      {{ endpoint().title }}
    </h1>
    <p class="m-0 mb-8 max-w-140 text-[14.5px] leading-relaxed text-neutral-subtitle">
      {{ endpoint().description }}
    </p>

    @if (endpoint().parameters.length > 0) {
      <h2 class="font-display m-0 mb-1 text-[17px]! font-bold! text-neutral-title">
        {{ endpoint().parametersTitle }}
      </h2>
      <div class="flex flex-col">
        @for (parameter of endpoint().parameters; track parameter.name) {
          <div class="flex flex-col gap-1 border-b border-solid neutral-border-lighter py-3.5">
            <div class="flex items-baseline gap-2.5">
              <span class="font-code text-[13px] font-semibold text-neutral-title">
                {{ parameter.name }}
              </span>
              <span class="font-code text-[11.5px] text-neutral-caption">{{ parameter.type }}</span>
              @if (parameter.required) {
                <span class="text-[11px] font-medium warning-text">required</span>
              }
            </div>
            <span class="text-[13.5px] leading-normal text-neutral-subtitle">
              {{ parameter.description }}
            </span>
          </div>
        }
      </div>
    }

    <h2 class="font-display mt-8 mb-2 text-[17px]! font-bold! text-neutral-title">Returns</h2>
    <p class="m-0 max-w-140 text-[13.5px] leading-relaxed text-neutral-subtitle">
      {{ endpoint().returns }}
    </p>
  </article>

  <aside
    class="flex flex-col gap-4 surface-NC-blue-dark px-5 pt-6 pb-12 lg:sticky lg:top-16 lg:h-[calc(100vh-4rem)] lg:overflow-y-auto"
  >
    <div class="flex gap-1 self-start rounded-lg bg-white/6 p-1">
      @for (language of languages; track language.id) {
        <button
          class="cursor-pointer rounded-md border-none px-3 py-1.5 text-xs font-medium"
          type="button"
          [class.bg-white]="language.id === selectedLanguage()"
          [class.text-NC-blue-default]="language.id === selectedLanguage()"
          [class.bg-transparent]="language.id !== selectedLanguage()"
          [class.text-cca-newCold-100]="language.id !== selectedLanguage()"
          (click)="selectLanguage(language.id)"
        >
          {{ language.label }}
        </button>
      }
    </div>

    <div
      class="overflow-hidden rounded-[10px] border border-solid border-white/10 surface-NC-blue-default"
    >
      <div
        class="flex items-center justify-between border-b border-solid border-white/8 px-3.5 py-2"
      >
        <span class="text-[11px] font-medium tracking-wider text-cca-newCold-100 uppercase">
          Request
        </span>
        <button
          aria-label="Copy request sample"
          class="cursor-pointer border-none bg-transparent p-0 text-[13px] text-cca-newCold-100 hover:text-white"
          type="button"
          (click)="copySample('request')"
        >
          <cca-icon [icon]="copiedTarget() === 'request' ? 'check' : 'copy'" />
        </button>
      </div>
      <pre class="font-code m-0 overflow-x-auto p-4 text-xs leading-relaxed text-cca-newCold-50">{{
        requestSample()
      }}</pre>
    </div>

    @if (responseSample(); as sample) {
      <div
        class="overflow-hidden rounded-[10px] border border-solid border-white/10 surface-NC-blue-default"
      >
        <div
          class="flex items-center justify-between border-b border-solid border-white/8 px-3.5 py-2"
        >
          <span class="text-[11px] font-medium tracking-wider text-cca-newCold-100 uppercase">
            Response · {{ responseStatus() }}
          </span>
          <button
            aria-label="Copy response sample"
            class="cursor-pointer border-none bg-transparent p-0 text-[13px] text-cca-newCold-100 hover:text-white"
            type="button"
            (click)="copySample('response')"
          >
            <cca-icon [icon]="copiedTarget() === 'response' ? 'check' : 'copy'" />
          </button>
        </div>
        <pre
          class="font-code m-0 overflow-x-auto p-4 text-xs leading-relaxed text-cca-newCold-50"
          >{{ sample }}</pre>
      </div>
    }
  </aside>
</div>
